import { render, staticRenderFns } from "./grid-amount-left-filter.vue?vue&type=template&id=21d18a99&"
import script from "./grid-amount-left-filter.ts?vue&type=script&lang=js&"
export * from "./grid-amount-left-filter.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports